import React from 'react';

import { Card, Grid, Button } from '@material-ui/core';

import TitleBanner from '../../design-system/components/Banners/TitleBanner';
import Table from '../../design-system/components/Table/Table';
import TableFilter from '../../design-system/components/Table/TableFilter/TableFilter';
import LoaderContent from '../../design-system/components/Loader/LoaderContent';
import NothingFound from '../../components/NothingFound/NothingFound';

import { AdminService } from '@sdk-point/talisis';
import writeXlsxFile from 'write-excel-file';
import moment from 'moment';

import { AsyncroDocumentsTable, excelAsyncroDocuments } from './ColumnsTable';
import { commonModuleStyles } from '../../assets/styles/jss/pages/common/CommonModuleStyles';

const AdminServiceSDK = new AdminService(
    process.env.REACT_APP_ENV_V2,
    process.env.REACT_APP_X_API_KEY_V2
);

const Document = () => {
    const classes = commonModuleStyles();

    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({
        month: '',
        year: ''
    });

    const [searchFilter, setSearchFilter] = React.useState({
        month: '',
        year: new Date().getFullYear()
    });

    const months = [
        { id: '', label: 'Seleccionar mes' },
        { id: '01', label: 'Enero' },
        { id: '02', label: 'Febrero' },
        { id: '03', label: 'Marzo' },
        { id: '04', label: 'Abril' },
        { id: '05', label: 'Mayo' },
        { id: '06', label: 'Junio' },
        { id: '07', label: 'Julio' },
        { id: '08', label: 'Agosto' },
        { id: '09', label: 'Septiembre' },
        { id: '10', label: 'Octubre' },
        { id: '11', label: 'Noviembre' },
        { id: '12', label: 'Diciembre' }
    ];

    const validateFilters = (filters = searchFilter) => {
        const newErrors = {
            month: '',
            year: ''
        };
        let isValid = true;

        if (!filters.month || filters.month === '') {
            newErrors.month = 'El mes es requerido';
            isValid = false;
        }

        if (!filters.year || filters.year === '') {
            newErrors.year = 'El año es requerido';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const getRequests = async (filters = searchFilter) => {
        // Validar antes de ejecutar la consulta
        if (!validateFilters(filters)) {
            return;
        }

        setLoading(true);

        try {
            const response = await AdminServiceSDK.getReportAsynchronousdocuments({
                month: filters.month,
                year: filters.year

            });

            setRows(response.data);
            // Limpiar errores si la consulta fue exitosa
            setErrors({ month: '', year: '' });

        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    };

    const handledDownLoadExcel = async () => {
        try {
            setLoading(true);

            await writeXlsxFile(rows, {
                schema: excelAsyncroDocuments,
                fileName: `Reporte de Documentos Asincronos ${moment().format(
                    'YYYY-MM-DD HH:mm:ss'
                )}.xlsx`
            });
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    return (
        <Grid container spacing={2}>

            {/* Banner */}
            <Grid item xs={12}>
                <TitleBanner
                    title="Reporte de Documentos Asincrónicos"
                    desc="Consulte el detalle de usuarios asincrónicos que ingresaron en el mes seleccionado."
                />
            </Grid>

            {/* Contenedor principal */}
            <Grid item xs={12}>
                <Card>
                    <LoaderContent loading={loading} minHeight={200}>


                        <TableFilter>

                            {/* selector MES */}
                            <Grid item>
                                <div>
                                    <select
                                        value={searchFilter.month}
                                        onChange={(e) => {
                                            const value = e.target.value;   
                                            setSearchFilter(prev => ({
                                                ...prev,
                                                month: value
                                            }));
                                            // Limpiar error al cambiar el valor
                                            if (errors.month) {
                                                setErrors(prev => ({ ...prev, month: '' }));
                                            }
                                        }}
                                        style={{
                                            width: 200,
                                            padding: '10px',
                                            borderRadius: 8,
                                            border: errors.month ? '1px solid #f44336' : '1px solid #ccc',
                                            fontSize: 14
                                        }}
                                    >
                                        {months.map((m) => (
                                            <option key={m.id} value={m.id}>
                                                {m.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.month && (
                                        <div style={{ color: '#f44336', fontSize: '12px', marginTop: '4px' }}>
                                            {errors.month}
                                        </div>
                                    )}
                                </div>
                            </Grid>

                            {/* selector AÑO */}
                            <Grid item>
                                <div>
                                    <input
                                        type="number"
                                        value={searchFilter.year}
                                        onChange={(e) => {
                                            const value = e.target.value;  
                                            setSearchFilter(prev => ({
                                                ...prev,
                                                year: value
                                            }));
                                            // Limpiar error al cambiar el valor
                                            if (errors.year) {
                                                setErrors(prev => ({ ...prev, year: '' }));
                                            }
                                        }}
                                        style={{
                                            width: 150,
                                            padding: '10px',
                                            borderRadius: 8,
                                            border: errors.year ? '1px solid #f44336' : '1px solid #ccc',
                                            fontSize: 14
                                        }}
                                    />
                                    {errors.year && (
                                        <div style={{ color: '#f44336', fontSize: '12px', marginTop: '4px' }}>
                                            {errors.year}
                                        </div>
                                    )}
                                </div>
                            </Grid>

                            {/* Botón aplicar */}
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => getRequests(searchFilter)}
                                    style={{
                                        width: 160,
                                        height: 45
                                    }}
                                >
                                    Aplicar
                                </Button>
                            </Grid>

                            {/* Botón excel */}
                            <Grid item>
                                <Button
                                    variant="contained"
                                    style={{
                                        width: 200,
                                        height: 45,
                                        backgroundColor: '#6c63ff',
                                        color: '#fff'
                                    }}
                                    onClick={handledDownLoadExcel}
                                >
                                    Descargar Excel
                                </Button>
                            </Grid>

                        </TableFilter>


                        {/* TABLA */}
                        {rows.length > 0 ? (
                            <Table
                                columns={AsyncroDocumentsTable}
                                rows={rows}
                                loading={loading}
                                className={classes.table}
                            />
                        ) : (
                            !loading && (
                                <NothingFound
                                    width="200px"
                                    caption="Selecciona tu criterio de búsqueda dando click en el botón de Aplicar."
                                    subcaption="Filtra por mes y año"
                                />
                            )
                        )}


                    </LoaderContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Document;
